import http from "../../axios-config/g-http-metodos";

function GetTiposOrcamento(){
    const { res, erro, requisicao } = http.getArray("OrcamentoSequencia/GetTipoOrcamentoEnum");
    return { TiposOrcamentoArray: res, erro, requisicao }
}

function PostOrcamentoSequencia (parametro, orcamentoId) {
    const { res, erro, requisicao } = http.post(`OrcamentoSequencia/PostOrcamentoSequencia`, parametro, orcamentoId)
    return { OrcamentoSequencia: res, erro, requisicao}
}

function GetOrcamentoSequenciaByOrcamentoId(orcamentoId){
    const { res, erro, requisicao} = http.get(`OrcamentoSequencia/GetOrcamentoSequenciaByOrcamentoId/${orcamentoId}`)
    return {OrcamentoSequencia: res, erro, requisicao}
  }

function ReprocessarOrcamentoSequenciaAsync(orcamentoId){
    const { res, erro, requisicao} = http.get(`OrcamentoSequencia/ReprocessarOrcamentoSequenciaAsync/${orcamentoId}`)
    return {OrcamentoSequencia: res, erro, requisicao}
  }

const OrcamentoSequenciaController = {
    GetTiposOrcamento,
    PostOrcamentoSequencia,
    GetOrcamentoSequenciaByOrcamentoId,
    ReprocessarOrcamentoSequenciaAsync
}

export default OrcamentoSequenciaController
